import { ButtonProps, Button } from "react-bootstrap";
import getClasses from "utils/getClasses";

const OutlinePrimaryButton = ({ className, ...props }: ButtonProps) => (
  <Button
    variant="outline-primary"
    size="sm"
    className={getClasses("px-5", className)}
    {...props}
  />
);

export default OutlinePrimaryButton;
